export default {
  app: {
    title: 'Scribe',
    description: 'Sous-titres et transcriptions automatiques',
  },
  title: 'Sous-titres',
  loadingText: 'Chargement des sous-titres...',
  createButton: 'Créer',
  newButton: 'Nouveau',
  viewGrid: 'Vue grille',
  viewList: 'Vue liste',
  list: {
    name: 'Nom',
    subtitles: 'Sous-titres',
    review: 'Vérification',
    duration: 'Durée',
    date: 'Date',
    actions: 'Actions',
  },
  comingSoon: {
    title: 'Bientôt disponible',
    description: 'Cette fonctionnalité est en cours de développement.',
  },
  error: {
    title: 'Erreur de chargement',
    description: 'Une erreur est survenue lors du chargement de vos sous-titres. Veuillez réessayer.',
    retryButton: 'Réessayer',
  },
  generation: {
    started: 'Génération des sous-titres lancée',
    error: 'Erreur lors du lancement de la génération',
    partialError: '{failed} langue(s) en échec',
    inProgress: 'Génération en cours…',
    failed: 'Échec de la génération',
    retry: 'Relancer la génération',
    retryStarted: 'Génération relancée',
    retryError: 'Impossible de relancer la génération',
    // A transcription that failed in the background: the list's card and the toast.
    transcriptionFailed: {
      title: 'Échec de la transcription',
      hint: 'La transcription n’a pas abouti. Vous pouvez la relancer.',
      toast: 'La transcription a échoué',
      toastNamed: 'La transcription de « {name} » a échoué',
      retry: 'Relancer',
      dismiss: 'Masquer',
    },
    // A transcription that heard nothing: the wizard, the list's card and the toast.
    noSpeech: {
      title: 'Aucune parole détectée',
      description: 'Cette vidéo ne contient pas de paroles : les sous-titres automatiques ne peuvent pas être générés. Vous pouvez importer un fichier de sous-titres.',
      short: 'Aucune parole',
      hint: 'Les sous-titres automatiques ne peuvent pas être générés.',
      toast: 'Aucune parole détectée : les sous-titres n’ont pas pu être générés',
      toastNamed: 'Aucune parole détectée dans « {name} »',
      see: 'Voir',
      import: 'Importer un fichier .srt/.vtt',
      dismiss: 'Masquer',
    },
  },
  filter: {
    searchPlaceholder: 'Rechercher un projet…',
    review: {
      all: 'Tous les projets',
      internalGroup: 'Votre vérification',
      todo: 'À vérifier',
      wip: 'Vérification en cours',
      done: 'Vérifiés',
      externalGroup: 'Relecture externe',
      extSent: 'Envoyés en relecture',
      extDone: 'Relus par un externe',
    },
    noResults: {
      title: 'Aucun projet ne correspond aux filtres',
      description: 'Ajustez votre recherche ou vos filtres.',
      clear: 'Réinitialiser les filtres',
    },
    types: {
      video: 'Vidéo',
      audio: 'Audio',
      imported: 'Importés',
    },
  },
  assetType: {
    video: 'Vidéo',
    audio: 'Audio',
    subtitles: 'Importé',
  },
  emptyState: {
    title: 'Démarrez le sous-titrage de vos vidéos',
    description: 'Cette fonctionnalité vous permet de générer des sous-titres et des transcriptions pour vos vidéos. Cliquez sur "Commencer" pour lancer le traitement.',
    buttonText: 'Commencer',
  },
  header: {
    title: 'Éditeur de',
    titleAccent: 'sous-titres',
    subtitleEmpty: 'Transcrivez, traduisez et éditez les sous-titres de vos vidéos — dans plus de 100 langues.',
    subtitleFilled: 'Aucun projet | 1 projet | {total} projets',
    hint: 'Retrouvez ici vos sous-titrages récents. Tous les sous-titres restent accessibles directement depuis chaque vidéo dans la bibliothèque.',
    newProject: 'Nouveau',
  },
  empty: {
    heroTitle: 'Votre premier projet de sous-titrage',
    heroDescription: 'Choisissez une vidéo depuis votre bibliothèque ou uploadez un nouveau fichier. On détecte automatiquement la langue et on vous prépare une transcription.',
    fromLibrary: 'Choisir depuis ma bibliothèque',
    uploadFile: 'Uploader une vidéo',
    demoTitle: 'Regarder la présentation',
    demoSubtitle: 'Découvrez Scribe en vidéo',
    howItWorksTitle: 'Comment ça marche',
    languagesTitle: 'Plus de 100 langues',
    languagesSubtitle: 'Transcription et traduction automatiques · précision 98%',
    steps: {
      import: {
        title: 'Importez votre vidéo',
        description: 'MP4, MOV, WebM — jusqu\'à 2 Go',
      },
      transcribe: {
        title: 'Transcription auto',
        description: 'Dans plus de 100 langues, avec les horaires au mot près',
      },
      edit: {
        title: 'Éditez & stylisez',
        description: 'Corrigez, segmentez, habillez vos sous-titres',
      },
      export: {
        title: 'Exportez',
        description: 'SRT, VTT, ou vidéo MP4 avec burn-in',
      },
    },
  },
  card: {
    created: 'Créé le',
    downloadLanguage: 'Télécharger ({language})',
    subtitlesOnly: 'Sous-titres uniquement',
    linkVideo: 'Lier une vidéo',
    noVideo: 'Aucune vidéo associée',
    noReadySubtitles: 'Aucun sous-titre disponible',
  },
  nav: {
    glossary: 'Glossaire',
    vocabulary: 'Vocabulaire',
    sync: 'Synchronisation',
    style: 'Style par défaut',
  },
  editor: {
    title: 'Éditeur de sous-titres',
    linkError: "La vidéo n'a pas pu être associée à ces sous-titres.",
    styleSaveError: "Le style n'a pas été enregistré. Vos changements restent affichés et seront renvoyés à la prochaine modification.",
    undo: 'Annuler',
    redo: 'Rétablir',
    saved: 'Enregistré',
    saving: 'Enregistrement...',
    unsaved: 'Modifications non enregistrées',
    saveTooltip: 'Enregistrer les modifications (Ctrl+S)',
    allChangesSaved: 'Toutes les modifications sont enregistrées',
    loading: 'Chargement en cours...',
    welcome: {
      close: 'Fermer',
      title: 'Bienvenue — vos sous-titres sont là',
      subtitle: '« {name} » et vos corrections ont rejoint votre espace.',
      defaultFile: 'Votre vidéo',
      journey: {
        from: 'Sous-titrage express',
        to: 'Votre espace Scribe',
        moved: 'on a tout récupéré pour vous',
      },
      destsTitle: 'Où retrouver votre travail :',
      dest: {
        mediaHint: 'Votre vidéo et ses sous-titres',
        editor: 'Éditeur Scribe',
        editorHint: 'Reprendre, styliser, exporter',
        translate: 'Traduire',
        translateHint: 'Toucher une audience internationale',
      },
      badge: {
        here: '1 fichier',
        languages: '100+ langues',
      },
      tip: {
        title: 'Vos exports, quand vous voulez',
        text: 'Téléchargez en SRT, VTT, TXT ou DOCX depuis l’éditeur, autant de fois que nécessaire.',
      },
      actions: {
        openEditor: 'Continuer l’édition',
        newFile: 'Sous-titrer un autre fichier',
      },
    },
    unsavedChanges: 'Modifications non enregistrées',
    unsavedChangesMessage: 'Vous avez des modifications non enregistrées. Voulez-vous les enregistrer avant de quitter ?',
    autoSaveError: 'Échec de la sauvegarde automatique. Cliquez sur l\'icône pour réessayer.',
    saveError: 'Échec - Cliquez pour réessayer',
    openInMediasbox: 'Ouvrir dans Mediasbox',
    breadcrumb: {
      label: 'Fil d\'Ariane',
      scribe: 'Scribe',
      backToScribe: 'Retour à Scribe',
      openAsset: 'Voir le média',
    },
    autoGenerated: 'Sous-titre généré automatiquement',
    manual: 'Sous-titre créé manuellement',
    auto: 'Auto',
    manualShort: 'Manuel',
    noSegments: 'Aucun sous-titre',
    noSegmentsHint: 'Ajoutez votre premier sous-titre pour commencer',
    addFirstSegment: 'Ajouter un sous-titre',
    tabs: {
      subtitles: 'Sous-titres',
      transcription: 'Transcription',
      languages: 'Langues',
      styles: 'Style',
      search: 'Recherche',
      speakers: 'Intervenants',
    },
  },
  review: {
    reviewed: 'vérifié',
    reviewedTooltip:
      'Les segments que vous avez cochés ✓ dans l’éditeur. C’est un repère pour votre suivi : il ne bloque ni l’export ni la publication. Pour faire relire par quelqu’un d’autre, utilisez « Partager pour relecture ».',
    checkSegment: 'Marquer comme vérifié',
    uncheckSegment: 'Marquer comme non vérifié',
    checkAll: 'Tout cocher',
    uncheckAll: 'Tout décocher',
    checkAllTitle: 'Tout marquer comme vérifié ?',
    checkAllText: '{n} segment(s) seront cochés comme vérifiés. Vous pourrez annuler avec Ctrl+Z.',
    uncheckAllTitle: 'Tout décocher ?',
    uncheckAllText: 'Les {n} segments repasseront à « non vérifié ». Vous pourrez annuler avec Ctrl+Z.',
    uncertain: 'Scribe hésite',
    markAllPreviousAsReviewed: 'Cocher jusqu’ici',
    hideReviewed: 'Afficher tous les segments',
    showOnlyUnreviewed: 'Afficher uniquement les non vérifiés',
    allChecked: 'Tout est vérifié',
    allCheckedHint: 'Le filtre n’affiche que les segments non vérifiés, et il n’en reste aucun sur cette piste.',
    progress: '{reviewed}/{total} segments vérifiés',
    complete: 'Relu',
    none: 'Non relu',
    inProgress: 'Relecture en cours',
    autoGenerated: 'Généré automatiquement',
    share: {
      button: 'Partager pour relecture',
      buttonShort: 'Partager',
      title: 'Partager pour relecture',
      subtitle: 'Le relecteur corrige vos sous-titres directement dans Scribe. Ses corrections vous reviennent en suggestions — aucun fichier à échanger.',
      thisMedia: 'Ce média',
      autoSubtitles: 'Sous-titres auto',
      languages: 'Langues à relire',
      who: 'Qui relit ?',
      byEmail: 'Inviter par email',
      byLink: 'Lien de partage',
      emailPlaceholder: "relecteur{'@'}exemple.com",
      linkNote: 'Un lien à partager avec qui vous voulez.',
      returnMode: 'Comment reviennent les corrections',
      suggestionTitle: 'En suggestions à valider',
      suggestionDesc: 'Vous acceptez ou ignorez chaque correction. Recommandé si vous ne parlez pas la langue.',
      directTitle: 'Appliquées directement',
      directDesc: 'Les corrections sont appliquées à la piste immédiatement. Plus rapide, moins de contrôle.',
      expiration: 'Le lien expire',
      expire14: 'Dans 14 jours',
      expire7: 'Dans 7 jours',
      expire30: 'Dans 30 jours',
      expire90: 'Dans 90 jours',
      noPublicUrl: 'Cette installation ne publie pas d’adresse : transmettez le jeton affiché dans la réponse.',
      message: 'Message (optionnel)',
      messagePlaceholder: 'Bonjour, pouvez-vous vérifier la traduction ? Merci !',
      preview: 'Le relecteur ouvre Scribe sans compte, guidé sur les passages où l’IA a hésité.',
      submitEmail: 'Envoyer l’invitation',
      submitLink: 'Créer le lien',
      createError: 'Impossible de créer le lien de relecture. Réessayez.',
      doneSubtitle: 'Copiez le lien ci-dessous et envoyez-le à votre relecteur.',
      emailSentSubtitle: 'Le lien de relecture a été envoyé par email à {email}.',
      copyButton: 'Copier',
      copied: 'Copié',
      doneButton: 'Terminé',
      linkHint: 'Le relecteur ouvre Scribe en mode relecture, sans compte.',
      noSubtitle: 'Sélectionnez d’abord une piste de sous-titres.',
      close: 'Fermer',
    },
    reviewer: {
      banner: 'Vous relisez les sous-titres de « {media} ».',
      languagesToReview: '{count} langues à relire',
      submit: 'Envoyer la relecture',
      confirmTitle: 'Envoyer votre relecture ?',
      confirmMultiIntro: 'Vous allez envoyer votre relecture pour ces langues :',
      confirmHint: 'Vos corrections seront transmises au propriétaire, qui les validera.',
      confirmContinue: 'Continuer la relecture',
      loading: 'Chargement de la relecture…',
      submittedTitle: 'Merci !',
      submittedMessage: 'Vos corrections ont été envoyées. Le propriétaire va les relire et les appliquer.',
      notFoundTitle: 'Relecture indisponible',
      notFoundMessage: 'Ce lien de relecture est invalide, expiré ou révoqué.',
      errorTitle: 'Une erreur est survenue',
      errorMessage: 'La relecture n’a pas pu être chargée. Vérifiez votre lien et réessayez.',
      submitError: 'Votre relecture n’a pas pu être envoyée. Réessayez.',
      promoTitle: 'Sous-titrez vos propres vidéos',
      promoText: 'Scribe génère vos sous-titres automatiquement, les traduit en 100+ langues et vous laisse tout ajuster — sans installation.',
      promoCta: 'Essayer Scribe gratuitement',
      welcomeTitle: 'Relisez ces sous-titres',
      welcomeSubtitle: 'On vous a confié la relecture de « {media} ».',
      welcomeStep1: 'Écoutez',
      welcomeStep1Desc: 'la vidéo, ligne par ligne.',
      welcomeStep2: 'Corrigez',
      welcomeStep2Desc: 'le texte directement si quelque chose est faux.',
      welcomeStep3: 'Envoyez',
      welcomeStep3Desc: 'votre relecture : le propriétaire reçoit vos corrections.',
      startButton: 'Commencer la relecture',
      welcomeFoot: 'Aucun compte nécessaire · ça prend quelques minutes.',
      listen: 'Écouter ce passage',
      handledCount: 'Aucune ligne relue | 1 ligne relue | {n} lignes relues',
      validatedCount: '{done}/{total} validées',
      affirm: 'C’est bon',
      unaffirm: 'Annuler la validation',
      affirmed: 'Validée',
      alreadySent: 'Relecture envoyée',
      propose: 'Proposer',
      updateProposal: 'Mettre à jour',
      proposed: 'Proposée',
      withdraw: 'Retirer',
      original: 'Ligne actuelle',
      addComment: 'Ajouter un commentaire',
      commentPlaceholder: 'Ce que vous ne pouvez pas corriger vous-même : une ligne à couper, à fusionner…',
      startLabel: 'Début de la ligne',
      endLabel: 'Fin de la ligne',
      movedTitle: 'Cette ligne a changé',
      movedHint: 'Le propriétaire l’a modifiée pendant votre relecture : votre correction n’a pas été enregistrée. Comparez-la au nouveau texte, puis proposez-la à nouveau.',
      movedNow: 'Elle dit maintenant',
      takeNewText: 'Repartir du nouveau texte',
      proposeError: 'Votre correction n’a pas pu être enregistrée. Réessayez.',
      noMedia: 'La vidéo n’est pas disponible ici. Relisez les lignes telles quelles.',
      noLines: 'Cette piste ne contient aucune ligne.',
      onlyProposed: 'Mes lignes relues ({n})',
      noneProposed: 'Vous n’avez encore relu aucune ligne de cette piste.',
      onlyUncertain: 'Scribe hésite ({n})',
      noneUncertain: 'Plus aucune ligne en attente : vous les avez toutes relues.',
      uncertainTip: 'Les lignes en orange sont celles où Scribe a hésité. Vérifiez-les en priorité.',
      modeSuggest: 'Le propriétaire validera chaque correction, une par une.',
      modeDirect: 'Vos corrections seront appliquées dès l’envoi, sauf celles qui portent sur une ligne modifiée entre-temps.',
      confirmHintDirect: 'Vos corrections seront appliquées aux sous-titres dès l’envoi.',
    },
    owner: {
      title: 'Corrections proposées',
      from: 'Relu par {who}',
      aReviewer: 'un relecteur',
      noChanges: 'Aucune correction proposée — le relecteur n’a rien changé.',
      noneThisTrack: 'Aucune correction sur cette piste.',
      count: '{n} ligne(s) relue(s)',
      affirmed: 'Validée telle quelle',
      applied: 'Corrections appliquées.',
      partiallyApplied: '{n} correction(s) n’ont pas pu être appliquées : la ligne a changé ou a disparu.',
      applyError: 'Impossible d’appliquer les corrections. Réessayez.',
      applyN: 'Appliquer {accepted} · ignorer {rejected}',
      closeAfter: 'Clôturer la relecture',
      base: 'Avant',
      live: 'Actuel',
      proposed: 'Proposé',
      lineGone: 'La ligne n’existe plus dans la piste.',
      refusedHint: '{n} correction(s) n’ont pas été appliquées et restent en attente.',
      forbiddenHint:
        'Appliquer une correction réécrit les sous-titres : cela demande le droit de modifier les sous-titres dans l’espace de travail où se trouve ce média. Vous pouvez lire ce que le relecteur a proposé.',
      notDeciding: {
        open: 'Le relecteur n’a pas encore envoyé ses corrections : vous pouvez les lire, pas encore les appliquer.',
        closed: 'Cette relecture est clôturée : ses corrections se lisent, elles ne se décident plus.',
        revoked: 'Le lien de cette relecture a été révoqué : ses corrections se lisent, elles ne se décident plus.',
      },
      state: {
        applicable: 'À valider',
        applied: 'Déjà appliquée',
        conflict: 'Ligne modifiée',
        orphaned: 'Ligne disparue',
      },
      decision: {
        accepted: 'Acceptée',
        rejected: 'Ignorée',
        pending: 'En attente',
      },
      cannotAccept: {
        conflict: 'La ligne a changé depuis : reportez la correction à la main, puis ignorez-la.',
        orphaned: 'La ligne n’existe plus : reportez la correction à la main, puis ignorez-la.',
        applied: 'Déjà appliquée.',
        applicable: '',
        comment: 'Commentaire seul : rien à écrire sur la ligne.',
      },
    },
    inlineOwner: {
      languages: 'Langues',
      bannerFrom: 'Corrections de {who}',
      bannerAnonymous: 'Corrections d’un relecteur',
      proposals: '{n} à valider',
      before: 'Avant',
      after: 'Après',
      accept: 'Accepter',
      ignore: 'Ignorer',
      allDecided: 'tout est décidé',
      decidedSummary: '{accepted} acceptée(s), {rejected} ignorée(s)',
      applyHint: 'Acceptez ou ignorez au moins une correction',
      arbitrate: '{n} à arbitrer',
      affirmed: 'Le relecteur valide cette ligne telle quelle',
      atReview: 'À la relecture',
      now: 'Actuel',
      timing: 'Timing',
      acceptAll: 'Tout accepter',
      apply: 'Appliquer ({n})',
      finish: 'Terminer',
      noChangesShort: 'Aucune modification',
      finished: 'Relecture terminée',
      exit: 'Quitter',
      confirmApplyTitle: 'Appliquer les corrections ?',
      confirmApplyText: 'Les corrections acceptées seront appliquées à ces {n} langues, puis la relecture sera clôturée.',
      confirmCount: '{n} corrections',
      confirmNothing: 'Rien à changer',
      confirmApplyButton: 'Appliquer et terminer',
      onlyChanges: 'N’afficher que les corrections',
      noneThisLanguage: 'Aucune correction sur cette langue.',
      noProposals: 'Aucune correction — le relecteur a tout validé tel quel.',
      applied: 'Corrections appliquées.',
      applyError: 'Impossible d’appliquer les corrections. Réessayez.',
    },
    list: {
      tabProjects: 'Projets',
      tabReviews: 'Relectures',
      empty: 'Aucune relecture. Partagez une piste de sous-titres pour la faire relire.',
      groupToReview: 'À valider',
      groupInProgress: 'En cours',
      groupDone: 'Terminées',
      viewCorrectionsN: 'Voir les {n} corrections',
      trackCount: '1 piste | {n} pistes',
      expiresOn: 'Expire le {date}',
      revoke: 'Révoquer',
      revoked: 'Lien révoqué.',
      revokeError: 'Impossible de révoquer le lien. Réessayez.',
      rotatedHint: 'Un nouveau lien a été créé : l’ancien ne fonctionne plus. Copiez celui-ci — il ne sera plus affiché.',
      statusExpired: 'Expirée',
      status: {
        open: 'En attente du relecteur',
        submitted: 'Corrections reçues',
        closed: 'Clôturée',
        revoked: 'Révoquée',
      },
      sharedByLink: 'Lien de partage',
      sentOn: 'Envoyée le {date}',
      reviewedBadge: 'Relu',
      reviewedBadgeTooltip: 'Une relecture externe a été appliquée à ce média.',
      resent: 'Invitation renvoyée à {email}.',
      resend: 'Renvoyer le lien',
      resendError: 'Impossible d’envoyer l’invitation. Réessayez.',
      sendTitle: 'Renvoyer le lien de relecture',
    },
  },
  segment: {
    add: 'Ajouter',
    addBefore: 'Ajouter avant',
    split: 'Diviser',
    merge: 'Fusionner',
    deleteTitle: 'Supprimer le segment',
    deleteMessage: 'Ce sous-titre va disparaître. Êtes-vous sûr de vouloir continuer ?',
  },
  translate: {
    translateButton: 'Traduire',
    noTranslations: 'Aucune traduction en cours',
    startTranslation: 'Démarrer une traduction',
    allLanguagesAlreadyExist: 'Toutes les langues sélectionnées existent déjà',
    translationsQueued: '{count} traduction(s) démarrée(s)',
    translationCompleted: 'Traduction en {language} terminée',
  },
  languages: {
    title: 'Langues',
    addLanguage: 'Ajouter une langue',
    noLanguages: 'Aucune langue disponible',
    noLanguagesHint: 'Ajoutez une langue pour créer des sous-titres',
    default: 'Par défaut',
    cues: '{count} segments',
    words: '{count} mots',
    confidence: '{score}% de confiance',
    generatedBy: 'Généré par {service}',
    translationsInProgress: 'Traductions en cours',
    pending: 'En attente',
    failed: 'Échoué',
    waitingInQueue: 'En attente dans la file...',
    generatingSubtitles: 'Génération des sous-titres...',
    generationCompleted: 'Sous-titres {language} générés avec succès',
    generationFailed: 'Échec de la génération des sous-titres',
    retry: 'Réessayer',
    retryStarted: 'Relance de {language}…',
    retryError: 'Impossible de relancer la traduction.',
    delete: {
      title: 'Supprimer la langue',
      message: 'Êtes-vous sûr de vouloir supprimer les sous-titres en {language} ? Cette action est irréversible.',
      success: 'Langue supprimée avec succès',
      error: 'Échec de la suppression de la langue',
    },
  },
  // The cost of a generation, confirmed before it starts (`modals/SubtitlesCostConfirmModal.vue`)
  // and in the language modal's footer. The amounts are `billing.subtitlesCost`'s.
  costConfirm: {
    title: 'Générer les sous-titres',
    generate: 'Générer',
    generateFor: 'Générer · {amount}',
    after: 'Solde après la génération : {amount}.',
    short: 'Rechargez pour lancer la génération : rien n’est lancé ni débité avant.',
    shortReserve:
      'Votre solde couvre ce prix, mais pas ce qui serait débité de plus si la vidéo n’est dans aucune des langues choisies. Rechargez pour lancer la génération : rien n’est lancé ni débité avant.',
    neverFunded: 'Vous n’avez encore rien rechargé : le crédit acheté paie les sous-titres, le stockage et la diffusion.',
    topUpTitle: 'Recharger le portefeuille',
    topUpAndGenerate: 'Recharger {amount} et générer',
    creditPending: 'Paiement accepté. Le crédit met parfois une minute à arriver — la génération démarre dès qu’il est là.',
    creditLate: 'Votre paiement est bien passé, mais le crédit n’est pas encore arrivé. Réessayez de générer dans un instant.',
    refusedLabel: 'Sous-titres générés',
  },
  addLanguage: {
    title: 'Ajouter une langue',
    subtitle: 'Sélectionnez une ou plusieurs langues pour générer des sous-titres',
    labelOptional: 'Libellé (optionnel)',
    labelPlaceholder: 'ex: Sous-titres français',
    generate: 'Générer',
    generateMultiple: 'Générer {count} langues',
    generating: 'Démarrage de la génération...',
    selectLanguage: 'Sélectionnez une langue',
    noLanguagesAvailable: 'Toutes les langues ont déjà des sous-titres',
    multipleSelected: '{count} langues sélectionnées',
    success: 'Génération des sous-titres démarrée',
    successMultiple: '{count} générations de sous-titres démarrées',
    error: 'Échec du démarrage de la génération',
    noSpeechError:
      'Aucune parole détectée dans ce média : les sous-titres automatiques ne peuvent pas être générés. Vous pouvez importer un fichier de sous-titres.',
    waitingForTranscript: "Le média est d'abord transcrit ; ces langues démarreront dès que ce sera fait.",
    selected: 'Sélectionnées',
    popularLanguages: 'Langues populaires',
    allLanguages: 'Toutes les langues',
    searchPlaceholder: 'Rechercher une langue...',
    noResults: 'Aucune langue trouvée',
  },
  noVideo: {
    title: 'Aucune vidéo liée',
    description: 'Liez un fichier vidéo pour activer la chronologie et la prévisualisation.',
    linkFromLibrary: 'Choisir depuis la bibliothèque',
    uploadVideo: 'Télécharger une vidéo',
    tip: 'Vous pouvez éditer les sous-titres sans vidéo, mais en lier une permet la prévisualisation et une synchronisation précise.',
  },
  noAudio: {
    title: 'Aucun audio lié',
    description: 'Liez un fichier audio pour activer la chronologie et la prévisualisation.',
    linkFromLibrary: 'Choisir depuis la bibliothèque',
    uploadAudio: 'Télécharger un audio',
    tip: 'Vous pouvez éditer les sous-titres sans audio, mais en lier un permet la prévisualisation et une synchronisation précise.',
  },
  noMedia: {
    title: 'Aucun média lié',
    description: 'Liez un fichier vidéo ou audio pour activer la chronologie et la prévisualisation.',
    linkFromLibrary: 'Choisir depuis la bibliothèque',
    tip: 'Vous pouvez éditer les sous-titres sans média, mais en lier un permet la prévisualisation et une synchronisation précise.',
  },
  speakers: {
    detectTitle: 'Identifier les intervenants',
    detectHint:
      "Scribe écoute la vidéo et attribue à chaque ligne la voix qui y parle le plus, sans toucher au texte ni aux temps. Vous nommez ensuite chaque voix une fois pour toute la piste.",
    detect: 'Identifier les intervenants',
    detectAgain: 'Relancer la détection',
    queued: 'Détection en attente…',
    running: 'Détection en cours…',
    failed: "La détection n'a pas pu aboutir. Vous pouvez la relancer.",
    noLines: 'La piste doit avoir des lignes pour identifier les intervenants.',
    voices: 'Voix',
    loading: 'Chargement…',
    noVoices: "Aucune voix pour l'instant : lancez une détection.",
    unavailable: "Aucune voix n'est attribuée sur cette piste.",
    speaker: 'Intervenant {n}',
    add: 'Ajouter un intervenant',
    addPlaceholder: 'Nom - fonction',
    addFailed: "L'intervenant n'a pas pu être ajouté.",
    nameOf: 'Nom de {name}',
    colorOf: 'Couleur de {name}',
    lines: '{count} ligne | {count} ligne | {count} lignes',
    landed: '{count} voix identifiée | {count} voix identifiée | {count} voix identifiées',
    alreadyRunning: 'Une détection est déjà en cours sur cette piste.',
    askFailed: "La détection n'a pas pu être lancée.",
    saveFailed: "La voix n'a pas pu être enregistrée.",
    voiceOf: 'Voix de la ligne',
    nobody: 'Aucune voix',
  },
  search: {
    searchPlaceholder: 'Rechercher dans les sous-titres...',
    caseSensitive: 'Respecter la casse',
    wholeWord: 'Mot entier',
    replacePlaceholder: 'Remplacer par...',
    replaceAll: 'Remplacer tout',
    resultsCount: '{count} résultat(s)',
    replacedCount: '{count} résultat(s) ({replaced} remplacé(s))',
    replaceTooltip: 'Remplacer dans ce segment',
    noResults: 'Aucun résultat',
  },
  styles: {
    title: 'Style des sous-titres',
    customize: 'Personnaliser',
    resetToDefault: 'Style par défaut',
    resetToDefaultHint: "Revenir au style défini pour l'organisation dans Réglages › Style de Scribe.",
    scopeNotice: "Ce style s'applique à l'export de la vidéo avec sous-titres incrustés. Il ne s'applique pas au lecteur de la Mediasbox ni au lecteur à intégrer, qui affichent les sous-titres avec leur propre style.",
    font: 'Police',
    fontFamily: 'Famille de police',
    fontWeight: 'Épaisseur de police',
    fontSize: 'Taille de police',
    italic: 'Italique',
    uppercase: 'Majuscules',
    colors: 'Couleurs',
    textColor: 'Couleur du texte',
    backgroundColor: "Couleur d'arrière-plan",
    backgroundOpacity: "Opacité de l'arrière-plan",
    stroke: 'Contour',
    strokeWidth: 'Épaisseur du contour',
    strokeColor: 'Couleur du contour',
    position: 'Position',
    verticalPosition: 'Position verticale',
    karaoke: 'Karaoké',
    enableKaraoke: 'Activer le karaoké',
    currentWordColor: 'Couleur du mot courant',
    karaokeNoTimings: 'Le karaoké surligne chaque mot au moment où il est prononcé : il lui faut donc un minutage calé sur l\'audio. Seuls les sous-titres dans la langue d\'origine de la vidéo (la voix) en disposent — pas les traductions dans une autre langue, ni les fichiers importés.',
    videoFormat: 'Format vidéo',
    selectFormat: 'Sélectionner le format',
    categories: {
      all: 'Tous',
      social: 'Social',
      business: 'Business',
      retro: 'Rétro',
    },
  },
  download: {
    title: 'Exporter',
    chooseType: 'Que souhaitez-vous télécharger ?',
    subtitleFiles: 'Fichiers de sous-titres',
    subtitleFilesDesc: 'Téléchargez vos sous-titres au format SRT, VTT, ASS ou autres',
    videoWithSubtitles: 'Vidéo avec sous-titres',
    videoWithSubtitlesDesc: 'Exportez votre vidéo avec les sous-titres incrustés',
    back: 'Retour',
    language: 'Langue : {language}',
    format: 'Format de téléchargement',
    selectFormat: 'Sélectionner le format',
    selectSubtitles: 'Sélectionner les sous-titres à télécharger',
    selectTracks: 'Sélectionner les pistes à exporter',
    selectSubtitleLanguage: 'Sélectionner la langue des sous-titres à incruster',
    advancedOptions: 'Options avancées',
    includeMetadata: 'Inclure les métadonnées',
    zipMultiple: 'Télécharger en archive ZIP',
    useSlugFilename: 'Utiliser les noms techniques pour les fichiers',
    preview: 'Aperçu',
    downloadButton: 'Télécharger',
    exportButton: 'Exporter',
    includeVideo: 'Inclure la vidéo avec sous-titres incrustés',
    videoFormat: 'Format vidéo',
    videoFormatOriginal: 'Format original',
    videoFormatMP4: 'MP4',
    downloadingVideo: 'Téléchargement de la vidéo avec sous-titres...',
    shareButton: 'Partager',
    error: 'Échec du téléchargement des sous-titres',
    noSubtitles: 'Aucun sous-titre disponible à télécharger',
    processing: 'Traitement de la vidéo...',
    encodingVideo: 'Encodage de la vidéo avec les sous-titres',
    preparingVideo: 'Préparation du fichier vidéo',
    uploadingResult: 'Téléversement du résultat',
    exportComplete: 'Export terminé',
    exportFailed: 'Échec de l\'export',
    videoExport: {
      waitNotice:
        'L\'encodage peut prendre un moment selon la durée de la vidéo. Pas besoin de rester : vous retrouverez la vidéo dans vos transferts, en bas à droite, et par email si elle est longue.',
      progressTitle: 'On encode votre vidéo…',
      phase: {
        preparing: 'Préparation',
        encoding: 'Encodage',
        finalizing: 'Finalisation',
      },
      step: {
        preparing: 'Préparation de la vidéo',
        encoding: 'Incrustation des sous-titres',
        finalizing: 'Finalisation et mise à disposition',
      },
      phaseDesc: {
        preparing: 'On prépare votre fichier vidéo et les sous-titres stylisés.',
        encoding:
          'Les sous-titres sont gravés dans l\'image, image par image. C\'est l\'étape la plus longue.',
        finalizing: 'On met votre vidéo à disposition au téléchargement.',
      },
      reassure:
        'Vous pouvez fermer cette fenêtre et continuer à travailler. L\'export se poursuit dans vos transferts, en bas à droite.',
      reassureEmail: 'Comme la vidéo est longue, un email vous sera aussi envoyé à {email}.',
      reassureEmailNoAddress: 'Comme la vidéo est longue, un email vous sera aussi envoyé dès que c\'est prêt.',
      continueBackground: 'Continuer en arrière-plan',
      completeTitle: 'Votre vidéo est prête',
      completeDesc:
        'Le téléchargement démarre. Vous la retrouverez aussi dans vos transferts.',
      downloadAgain: 'Télécharger à nouveau',
      startError: 'Impossible de démarrer l\'export. Veuillez réessayer.',
      retry: 'Réessayer',
    },
  },
  export: {
    restricted: {
      all: "Votre rôle ne permet pas d'exporter cette vidéo. Pour cela, rapprochez-vous d'un administrateur de l'espace de travail.",
      files: "Votre rôle ne permet pas d'exporter les sous-titres ni le transcript. Pour cela, rapprochez-vous d'un administrateur de l'espace de travail.",
      burn: "Votre rôle ne permet pas d'exporter la vidéo avec sous-titres incrustés. Pour cela, rapprochez-vous d'un administrateur de l'espace de travail.",
    },
    title: 'Export',
    subtitle: 'Que souhaitez-vous exporter ?',
    chooseType: 'Que voulez-vous télécharger ?',
    subtitlesOnly: 'Sous-titres',
    subtitleScript: 'Fichier de sous-titres',
    subtitleScriptDesc: 'Dans le format sélectionné',
    subtitlesOnlyDesc: 'Télécharger les fichiers de sous-titres dans le format de votre choix',
    video: 'Vidéo',
    videoWithSubtitles: 'Vidéo avec sous-titres',
    videoWithSubtitlesDesc: 'Un fichier mp4 avec les sous-titres intégrés',
    comingSoon: 'À venir',
    selectLanguage: 'Sélectionner la langue',
    selectLanguages: 'Sélectionner les langues',
    format: 'Format',
    videoFormat: 'Format vidéo',
    videoInfo: 'La vidéo sera exportée au format MP4 avec les sous-titres incrustés',
    socialNetworks: 'Réseaux sociaux',
    currentLanguage: 'Langue actuelle',
    selectedFormat: 'Format sélectionné',
    transcript: 'Transcription',
    transcriptDesc: 'Le texte par intervenant, avec les timecodes : Word, Excel ou TXT',
    columns: { timecode: 'Timecode', speaker: 'Intervenant', text: 'Texte' },
    exportFormat: "Format d'export",
  },
  upload: {
    uploading: 'Téléchargement...',
    started: 'Téléchargement commencé',
    error: 'Échec du téléchargement',
    plannedSubtitles: 'Sous-titres à générer',
    status: {
      preparing: 'Préparation du téléchargement...',
      uploading: 'Téléchargement du fichier...',
      processing: 'Traitement de la vidéo...',
    },
    // An import that failed and can still be resumed: its card, its toast and the processing modal.
    failed: {
      title: 'Échec de l\'import',
      hint: 'Reprenez-le : les sous-titres seront demandés dès qu\'il aura abouti.',
      retry: 'Reprendre l\'import',
      toastNamed: 'L\'import de « {name} » a échoué. {reason}',
      resumable: '{reason} Reprenez l\'import depuis le panneau Transferts : les sous-titres seront demandés dès qu\'il aura abouti.',
    },
    modal: {
      title: 'Télécharger une vidéo',
      configure: 'Configurer les sous-titres',
      dragDrop: 'Glissez-déposez votre vidéo ici',
      dropHere: 'Déposez votre fichier ici',
      or: 'ou',
      browse: 'Parcourir les fichiers',
      fromLibrary: 'Choisir depuis la bibliothèque',
      uploadNew: 'Télécharger une nouvelle vidéo',
      uploadNewDescription: 'Glissez-déposez ou parcourez pour télécharger un nouveau fichier vidéo',
      fromLibraryDescription: 'Sélectionnez une vidéo existante depuis votre bibliothèque',
      importSubtitle: 'Importer SRT/VTT',
      importSubtitleDescription: 'Importer un fichier de sous-titres existant',
      dragDropSubtitle: 'Glissez-déposez votre fichier SRT/VTT ici',
      dropSubtitleHere: 'Déposez votre fichier de sous-titres ici',
      supportedSubtitleFormats: 'Formats supportés : SRT, VTT',
      import: 'Importer',
      errorInvalidSubtitleFormat: 'Format de fichier invalide. Veuillez utiliser un fichier .srt ou .vtt',
      errorParsingSubtitle: 'Erreur lors du traitement du fichier de sous-titres',
      subtitleParsedSuccess: '{count} segments détectés ({format})',
      chooseMethod: 'Comment souhaitez-vous ajouter votre vidéo ?',
      chooseMethodDescription: 'Choisissez de télécharger une nouvelle vidéo ou de sélectionner depuis votre bibliothèque',
      tryDifferentFilter: 'Essayez un filtre différent ou un autre terme de recherche',
      supportedFormats: 'Formats supportés : MP4, AVI, MOV, MKV, WebM',
      libraryTitle: 'Bibliothèque de vidéos',
      searchVideos: 'Rechercher des vidéos...',
      filterAll: 'Toutes',
      filterNoSubtitles: 'Sans sous-titres',
      filterRecent: 'Récentes',
      noSubtitles: 'Aucun sous-titre',
      noVideosFound: 'Aucune vidéo trouvée',
      select: 'Sélectionner',
      existingVideo: 'Vidéo existante',
      existingSubtitles: 'Cette vidéo possède déjà les sous-titres suivants :',
      allowRegeneration: 'Autoriser la régénération des sous-titres existants',
      selectLanguages: 'Sélectionnez les langues de sous-titres à générer',
      popular: 'Populaire',
      presetPopular: 'Langues populaires',
      presetEurope: 'Langues européennes',
      presetAll: 'Toutes les langues',
      advancedOptions: 'Options avancées',
      audioDescription: 'Audio-description',
      simplified: 'Simplifié (Facile à lire)',
      summary: '{count} langue(s) sélectionnée(s)',
      additionalSubtitles: 'Supplémentaire : {types}',
      startUpload: 'Démarrer le téléchargement',
      errorNotVideo: 'Veuillez sélectionner un fichier vidéo',
      errorTooLarge: 'Le fichier est trop volumineux (max 2 Go)',
    },
  },
  delete: {
    title: 'Supprimer la vidéo',
    message: 'Êtes-vous sûr de vouloir supprimer "{video}" et tous ses sous-titres ? Cette action est irréversible.',
  },
  deleteSubtitles: {
    title: 'Supprimer les sous-titres',
    message: 'Êtes-vous sûr de vouloir supprimer {count} sous-titre(s) de « {video} » ? Cette action est irréversible.',
    success: 'Sous-titres supprimés avec succès',
    error: 'Échec de la suppression des sous-titres',
  },
  transcription: {
    copy: 'Copier la transcription',
    copied: 'Transcription copiée',
    showSpeakers: 'Afficher les intervenants',
  },
  task: {
    upload: 'Téléchargement',
    transcription: 'Transcription',
    translation: 'Traduction',
    status: {
      pending: 'En attente',
      running: 'En cours',
      completed: 'Terminé',
      failed: 'Échec',
    },
    retry: 'Réessayer',
    cancel: 'Annuler',
    remove: 'Supprimer',
    clearCompleted: 'Effacer terminés',
    noTasks: 'Aucune tâche',
    tasksInProgress: '{count} tâche(s) en cours',
  },
  modal: {
    title: 'Générer des sous-titres',
    chooseMethod: 'Comment souhaitez-vous ajouter des sous-titres ?',
    uploadNew: 'Télécharger vidéo/audio',
    uploadNewDescription: 'Téléchargez un nouveau fichier et générez des sous-titres',
    fromLibrary: 'Depuis la bibliothèque',
    fromLibraryDescription: 'Sélectionnez un fichier existant depuis votre bibliothèque',
    importSubtitle: 'Importer des sous-titres',
    importSubtitleDescription: 'Importez un fichier SRT ou VTT existant',
    dragDropVideo: 'Glissez-déposez votre vidéo ou audio ici',
    supportedVideoFormats: 'Formats supportés : MP4, MOV, AVI, MKV, MP3, WAV, M4A',
    changeAsset: 'Modifier la sélection',
    selectAsset: 'Sélectionner une vidéo ou un audio',
    selectAssetForSubtitle: 'Sélectionnez la vidéo/audio pour ce sous-titre',
    selectVideoOrAudio: 'Sélectionner un fichier vidéo ou audio',
    dragDropSubtitle: 'Glissez-déposez votre fichier de sous-titres ici',
    supportedSubtitleFormats: 'Formats supportés : SRT, VTT (max 10 Mo)',
    fileTooLarge: 'Le fichier est trop volumineux (max {maxSize})',
    validating: 'Validation du fichier...',
    words: 'Mots',
    cues: 'segments',
    destination: 'Destination',
    workspace: 'Espace de travail',
    folder: 'Dossier (optionnel)',
    folderPlaceholder: 'Rechercher un dossier...',
    selectLanguages: 'Sélectionnez les langues de sous-titres à générer',
    advancedOptions: 'Options avancées',
    audioDescription: 'Inclure les audio-descriptions',
    simplified: 'Simplifié (Facile à lire)',
    subtitleLanguage: 'Langue du sous-titre',
    language: 'Langue',
    labelOptional: 'Libellé (optionnel)',
    labelPlaceholder: 'ex : Sous-titres français',
    setAsDefault: 'Définir comme sous-titre par défaut',
    uploadAndGenerate: 'Télécharger et générer',
    generateSubtitles: 'Générer les sous-titres',
    uploadSubtitle: 'Télécharger le sous-titre',
    linkToAsset: 'Lier à une vidéo/audio',
    standalone: 'Fichier autonome',
    standaloneHint: 'Le fichier de sous-titres sera téléchargé comme un asset autonome. Vous pourrez le lier à une vidéo plus tard.',
    error: 'Erreur',
    processing: 'Traitement',
    complete: 'Terminé',
    errorTitle: 'Une erreur est survenue',
    successTitle: 'Sous-titres lancés',
    uploading: 'Téléchargement du fichier...',
    importing: 'Importation des sous-titres...',
    startingGeneration: 'Démarrage de la génération...',
    successMessage: 'La génération des sous-titres a démarré. Vous pouvez fermer cette fenêtre.',
    uploadingMessage: 'Téléchargement... {progress}%',
    pleaseWait: 'Veuillez patienter...',
  },
  settings: {
    title: 'Paramètres',
    backToSubtitles: 'Retour aux sous-titres',
    readOnly: "Ces réglages sont ceux de l'organisation : votre rôle permet de les consulter, pas de les modifier.",
    sections: {
      general: 'Général',
    },
    glossary: {
      title: 'Glossaire',
      description: "Les noms propres, marques, sigles et termes techniques de votre organisation, écrits comme ils doivent l'être. L'IA les respecte quand elle corrige ou traduit vos sous-titres.",
      add: 'Ajouter',
      addTerm: 'Ajouter un terme',
      editTerm: 'Modifier le terme',
      searchPlaceholder: 'Rechercher un terme…',
      noTerms: 'Aucun terme dans le glossaire',
      noTermsHint: "Ajoutez vos noms propres, marques et sigles, ou importez-les depuis un fichier CSV.",
      noResults: 'Aucun terme ne correspond',
      noResultsHint: 'Essayez une autre recherche ou retirez les filtres.',
      clearFilters: 'Retirer les filtres',
      count: '{count} terme | {count} termes',
      limit: "{count} termes sont actifs : l'IA n'en lit que {max}, par ordre alphabétique. Désactivez ceux qui servent le moins.",
      saved: 'Terme enregistré',
      saveError: "Le terme n'a pas été enregistré.",
      toggleError: "Le terme n'a pas pu être activé ou désactivé.",
      filters: {
        all: 'Tous',
        active: 'Actifs',
        inactive: 'Désactivés',
      },
      uses: {
        title: 'Où le glossaire est utilisé',
        correction: 'Correction par IA',
        correctionText: "L'IA corrige l'orthographe des termes, en s'aidant de leur prononciation.",
        translation: 'Traduction par IA',
        translationText: 'Les termes sont gardés tels quels, ou traduits comme vous l\'avez indiqué.',
        transcription: 'Transcription',
        transcriptionOn: 'Les termes sont donnés au modèle de transcription pour qu\'il les reconnaisse.',
        transcriptionOff: "La transcription n'utilise pas le glossaire : elle s'appuie sur le prompt des options de synchronisation.",
      },
      form: {
        term: 'Terme',
        termPlaceholder: 'Ex : Vidéas, Mediasbox, RSA',
        termHint: "Écrit exactement comme il doit apparaître dans les sous-titres.",
        phoneticHint: 'Prononciation',
        phoneticHintPlaceholder: 'Ex : vi-dé-as',
        phoneticHintHint: "Comment le mot se prononce : aide l'IA à le retrouver dans un texte mal transcrit.",
        context: 'Note',
        contextPlaceholder: 'Ex : nom du produit, toujours avec une majuscule',
        contextHint: "Pour votre équipe uniquement : la note n'est pas transmise à l'IA.",
        category: 'Catégorie',
        categoryPlaceholder: 'Ex : Marque, Élu, Commune',
        categoryHint: 'Pour ranger et filtrer vos termes.',
        isActive: 'Actif',
        isActiveHint: "Un terme désactivé reste dans la liste mais n'est plus utilisé.",
        required: 'Ce champ est requis',
        duplicate: 'Ce terme existe déjà pour cette langue.',
        cancel: 'Annuler',
        add: 'Ajouter',
        save: 'Enregistrer',
        delete: 'Supprimer',
      },
      delete: {
        title: 'Supprimer le terme',
        message: 'Êtes-vous sûr de vouloir supprimer le terme « {term} » du glossaire ? Cette action est irréversible.',
        success: 'Terme supprimé',
        error: "Le terme n'a pas pu être supprimé.",
      },
      import: {
        button: 'Importer',
        title: 'Importer des termes',
        description: 'Importez des termes depuis un fichier CSV pour remplir rapidement votre glossaire.',
        formatTip: 'Votre fichier CSV doit contenir les en-têtes de colonnes en première ligne. Utilisez la virgule ou le point-virgule comme séparateur. L\'encodage UTF-8 est recommandé.',
        requiredColumn: 'Colonne obligatoire : {column}',
        optionalColumns: 'Colonnes optionnelles : {columns}',
        downloadTemplate: 'Télécharger un modèle',
        replaceExisting: 'Remplacer tous les termes existants',
        replaceExistingHint: 'Tous les termes actuels du glossaire seront supprimés avant l\'import.',
        selectFile: 'Sélectionner un fichier',
        changeFile: 'Changer de fichier',
        termsFound: '{count} terme trouvé | {count} termes trouvés',
        termsSkipped: '{count} ligne ignorée (terme manquant) | {count} lignes ignorées (terme manquant)',
        importButton: 'Importer {count} terme | Importer {count} termes',
        importing: 'Import en cours...',
        success: 'Import terminé : {created} créé(s), {updated} mis à jour, {skipped} ignoré(s).',
        error: 'L\'import a échoué. Veuillez vérifier votre fichier et réessayer.',
        emptyFile: 'Le fichier ne contient aucune ligne de données.',
        noTermColumn: 'Aucune colonne « term » trouvée. Assurez-vous que votre fichier contient un en-tête nommé « term » ou « terme ».',
        parseError: 'Impossible de lire le fichier. Veuillez vérifier le format.',
      },
    },
    vocabulary: {
      title: 'Vocabulaire personnalisé',
      description: 'Ajoutez des termes spécifiques pour améliorer leur reconnaissance lors de la transcription automatique.',
      add: 'Ajouter',
      addTerm: 'Ajouter un terme',
      editTerm: 'Modifier le terme',
      termPlaceholder: 'Ajouter un nouveau terme...',
      searchPlaceholder: 'Rechercher un terme...',
      noTerms: 'Aucun terme personnalisé',
      noTermsHint: 'Ajoutez des termes pour améliorer la reconnaissance lors de la transcription',
      noResults: 'Aucun résultat',
      noResultsHint: 'Aucun terme ne correspond à votre recherche',
      saved: 'Vocabulaire enregistré avec succès',
      form: {
        term: 'Terme à reconnaître',
        termPlaceholder: 'Ex : Vidéas, COVID-19, SaaS, API REST',
        hint: 'Ce terme sera utilisé pour améliorer la reconnaissance lors de la transcription automatique.',
        required: 'Ce champ est requis',
        cancel: 'Annuler',
        add: 'Ajouter',
        save: 'Enregistrer',
      },
    },
    sync: {
      title: 'Options de synchronisation',
      description: "Comment vos vidéos sont transcrites et comment le texte est découpé en sous-titres. Les changements s'appliquent aux prochaines transcriptions, corrections et traductions ; les sous-titres existants ne bougent pas.",
      saved: 'Options enregistrées',
      saveError: "Les options n'ont pas été enregistrées.",
      sections: {
        transcription: 'Transcription',
        format: 'Lignes',
        timing: 'Rythme',
      },
      transcriptionLead: "Le prompt donne au modèle le contexte de vos vidéos : sujet, noms propres, sigles. Il est lu au début de chaque transcription.",
      initialPrompt: 'Prompt de transcription',
      initialPromptPlaceholder: 'Ex : Séance du conseil départemental de la Manche, avec le président, les rapporteurs et les élus.',
      promptHint: "Écrivez des phrases plutôt qu'une liste de mots. Pour imposer l'orthographe d'un terme lors des corrections IA, utilisez le glossaire.",
      promptWithGlossary: "Écrivez des phrases plutôt qu'une liste de mots. Les termes actifs du glossaire sont ajoutés avant le prompt.",
      toGlossary: 'Ouvrir le glossaire',
      formatLead: 'Appliqué aux corrections et traductions par IA : un sous-titre trop long y est coupé en plusieurs.',
      formatLeadShaping: 'Appliqué à chaque nouvelle transcription et aux corrections et traductions par IA : chaque sous-titre tient sur ce nombre de lignes.',
      maxLines: 'Lignes par sous-titre',
      maxCharsPerLine: 'Caractères par ligne',
      maxCharsHint: 'Entre 32 et 42 est le standard du sous-titrage.',
      sample: 'Exemple',
      sampleText: "Bienvenue à cette séance du conseil départemental. Nous allons examiner les rapports inscrits à l'ordre du jour, à commencer par le budget consacré aux collèges et aux transports scolaires.",
      timingLead: "Appliqué à chaque nouvelle transcription : les sous-titres lus trop vite sont coupés ou prolongés en s'appuyant sur le minutage de chaque mot.",
      maxCharsPerSecond: 'Vitesse de lecture (caractères par seconde)',
      cpsHint: 'Au-delà, un sous-titre est coupé ou reste affiché plus longtemps. 17 à 20 convient à la plupart des publics.',
      minDuration: 'Durée minimale',
      minDurationHint: "Un sous-titre n'est pas coupé avant d'avoir duré au moins ce temps.",
      maxDuration: 'Durée maximale',
      maxDurationHint: 'Un sous-titre plus long est coupé ; un sous-titre trop rapide n\'est pas prolongé au-delà.',
      slow: 'Lent',
      comfortable: 'Confortable',
      fast: 'Rapide',
      resetDefaults: 'Rétablir les valeurs par défaut',
      discard: 'Annuler les modifications',
      save: 'Enregistrer',
    },
    style: {
      title: 'Style par défaut',
      description: "Le style des sous-titres incrustés dans les vidéos exportées depuis Scribe, pour toute l'organisation. Une vidéo à laquelle vous donnez son propre style dans l'éditeur garde le sien.",
      saved: 'Style par défaut enregistré',
      saveError: "Erreur lors de l'enregistrement du style",
      loadError: 'Erreur lors du chargement du style',
      sections: {
        themes: 'Partir d\'un thème',
        text: 'Texte',
        background: 'Fond',
        stroke: 'Contour',
        position: 'Position',
      },
      themesHint: 'Un thème remplit les réglages ; ajustez-les si besoin, puis enregistrez.',
      allThemes: 'Voir les {count} thèmes',
      fewerThemes: 'Voir moins de thèmes',
      fontFamily: 'Police',
      fontSize: 'Taille',
      weightRegular: 'Normal',
      weightBold: 'Gras',
      italic: 'Italique',
      uppercase: 'Majuscules',
      textColor: 'Couleur du texte',
      backgroundColor: 'Couleur du fond',
      backgroundOpacity: 'Opacité du fond',
      backgroundHint: 'Le fond est un cadre derrière chaque ligne. À 0 %, il n\'y a pas de cadre et le texte garde son contour.',
      strokeWidth: 'Épaisseur',
      strokeColor: 'Couleur du contour',
      strokeBoxedHint: 'Sans effet tant que le fond est visible : l\'export dessine soit un cadre, soit un contour. Mettez l\'opacité du fond à 0 % pour utiliser le contour.',
      verticalPosition: 'Hauteur',
      verticalPositionHint: 'Distance au-dessus de la barre de contrôle des lecteurs, en pourcentage de la hauteur de la vidéo.',
      preview: 'Aperçu',
      previewFaithful: 'Aperçu fidèle à la vidéo exportée',
      showPlayerBar: "Barre d'un lecteur",
      previewText: 'Votre sous-titre apparaîtra ainsi\nsur la vidéo exportée.',
      resetDefaults: 'Rétablir le style Videas',
      discard: 'Annuler les modifications',
      save: 'Enregistrer',
    },
  },
  processing: {
    title: 'Traitement',
    openEditor: 'Ouvrir l\'éditeur',
    uploading: 'Téléchargement... {progress}%',
    canCloseHint: 'Vous pouvez fermer cette fenêtre. Le traitement continuera en arrière-plan.',
    status: {
      creating: 'Création des sous-titres...',
      pending: 'Préparation...',
      uploading: 'Téléchargement du fichier...',
      processing: 'Génération des sous-titres...',
      ready: 'Sous-titres prêts !',
      error: 'Une erreur est survenue',
    },
    description: {
      library: 'Génération des sous-titres pour votre vidéo...',
      upload: 'Téléchargement de votre fichier et génération des sous-titres...',
      srt: 'Importation de votre fichier de sous-titres...',
      ready: 'Vos sous-titres ont été générés avec succès.',
      error: 'Une erreur s\'est produite pendant le traitement.',
    },
    languageStatus: {
      pending: 'En attente',
      processing: 'En cours',
      ready: 'Prêt',
      error: 'Échec',
    },
    error: {
      missingData: 'Données manquantes pour le traitement',
      noAsset: 'Aucun fichier sélectionné',
      noFile: 'Aucun fichier sélectionné',
      noWorkspace: 'Il faut un espace pour ranger la vidéo générée. Créez-en un pour continuer.',
      noOrganization: 'Aucune organisation sélectionnée',
      uploadFailed: 'Échec du téléchargement',
      generation: 'Échec de la génération des sous-titres',
      credits: 'Solde insuffisant : rien n’a été lancé.',
      costDeclined: 'Génération annulée : rien n’a été lancé.',
      import: 'Échec de l\'importation du fichier de sous-titres',
      noSegments: 'Aucun sous-titre trouvé dans le fichier',
      allFailed: 'Toutes les générations de sous-titres ont échoué',
      generic: 'Une erreur est survenue lors de la création des sous-titres',
    },
  },
  wizard: {
    title: 'Créer des sous-titres',
    source: {
      title: 'Source',
      subtitle: 'Choisissez comment ajouter votre contenu',
      srt: {
        title: 'Importer des sous-titres',
        description: 'Télécharger un fichier SRT ou WebVTT',
      },
      upload: {
        title: 'Télécharger vidéo/audio',
        description: 'Télécharger un fichier vidéo ou audio à transcrire',
      },
      library: {
        title: 'Depuis la bibliothèque',
        description: 'Sélectionner un fichier existant depuis votre bibliothèque',
      },
    },
    file: {
      title: 'Fichier',
      destination: 'Destination',
      workspace: 'Espace de travail',
      folder: 'Dossier (optionnel)',
      folderPlaceholder: 'Rechercher un dossier...',
      uploadSrt: 'Télécharger un fichier de sous-titres',
      uploadMedia: 'Télécharger une vidéo ou un audio',
      srtFormats: 'Formats supportés : SRT, VTT, WebVTT (max 10 Mo)',
      mediaFormats: 'Formats supportés : MP4, MOV, AVI, MP3, WAV...',
      validating: 'Validation en cours...',
      validationFailed: 'Échec de la validation',
      cues: 'segments',
      words: 'mots',
      language: 'Langue',
      selectAsset: 'Sélectionner une vidéo ou un audio',
      targetAsset: 'Vidéo ou audio cible',
      targetAssetOptional: 'Associer à une vidéo ou un audio (optionnel)',
      selectTargetAsset: 'Sélectionner une vidéo ou un audio',
      selectTargetHint: 'Choisissez le fichier auquel rattacher les sous-titres',
      selectTargetOptionalHint: 'Ou passez cette étape pour ouvrir l\'éditeur sans média',
      selectFromLibrary: 'Sélectionner un fichier depuis votre bibliothèque',
      browseLibrary: 'Parcourir votre bibliothèque',
      browseHint: 'Cliquez pour ouvrir le sélecteur de fichiers',
    },
    languages: {
      title: 'Langues',
      subtitle: 'Sélectionnez les langues pour la génération des sous-titres',
      selected: 'Sélectionnées',
      addLanguages: 'Ajouter des langues',
      searchPlaceholder: 'Rechercher une langue...',
      noResults: 'Aucune langue trouvée',
      popular: 'Langues populaires',
      multipleSelected: '{count} langues sélectionnées',
    },
    validation: {
      selectSource: 'Veuillez sélectionner un type de source',
      selectFile: 'Veuillez sélectionner ou télécharger un fichier',
      selectAsset: 'Veuillez sélectionner une vidéo ou un audio cible',
      selectLanguage: 'Veuillez sélectionner au moins une langue',
      waitValidation: 'Veuillez patienter pendant la validation du fichier',
    },
  },
}
